import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { createContext } from "react";

const AccountsContext = createContext({
  updateSettings: () => { },
  settings: MatxLayoutSettings,
});

export const AccountsProvider = ({ children }) => {
  const [account, setAccount] = useState();
  const [config, setConfig] = useState();
  const [accounts, setAccounts] = useState();
  const [accountsRefreshTime, setAccountsRefreshTime] = useState(new Date());
  const [accountRefreshTime, setAccountRefreshTime] = useState(new Date());
  const [configRefreshTime, setConfigRefreshTime] = useState(new Date());
  const refreshAccount = () => {
    setAccountRefreshTime(new Date());
  };
  const refreshAccounts = () => {
    setAccountsRefreshTime(new Date());
  };
  const refreshConfig = () => {
    setConfigRefreshTime(new Date());
  };

  useEffect(() => {
    axios.get("/api/accounts").then(({ data }) => {
      setAccounts(data.items);
    });
  }, [accountsRefreshTime]);

  useEffect(() => {
    axios.get("/api/accounts/current").then(({ data }) => {
      setAccount(data);
    });
  }, [accountRefreshTime]);

  useEffect(() => {
    axios.get("/api/accounts/current/config").then(({ data }) => {
      setConfig(data);
    });
  }, [configRefreshTime, account]);

  return (
    <AccountsContext.Provider
      value={{
        accounts,
        refreshAccounts,
        account,
        refreshAccount,
        config,
        refreshConfig
      }}
    >
      {children}
    </AccountsContext.Provider>
  );
};

export default AccountsContext;
